var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkinScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8476 10.5005C10.8476 10.5005 10.3781 11.4243 8.99998 11.4243C7.62184 11.4243 7.15234 10.5005 7.15234 10.5005",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99987 13.7742C12.0554 13.7742 13.7742 12.0554 13.7742 8.99987C13.7742 5.94433 12.0554 4.22559 8.99987 4.22559C5.94433 4.22559 4.22559 5.94433 4.22559 8.99987C4.22559 12.0554 5.94433 13.7742 8.99987 13.7742Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84375 7.49658V8.02757",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1553 7.49658V8.02757",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6998 1.54004C13.1771 1.59149 13.6499 1.64681 14.1178 1.70104C15.263 1.83377 16.1764 2.74664 16.305 3.89234L16.3087 3.92604C16.3598 4.38081 16.4113 4.84022 16.4592 5.30387M12.6998 16.4597C13.1771 16.4082 13.6499 16.3529 14.1178 16.2987C15.263 16.1659 16.1764 15.2531 16.305 14.1074L16.3087 14.0736C16.3598 13.6189 16.4113 13.1595 16.4592 12.6959M5.29943 1.54004C4.82211 1.59149 4.34928 1.64681 3.88136 1.70104C2.73614 1.83377 1.82277 2.74664 1.69423 3.89234L1.69045 3.92604C1.63943 4.38081 1.58788 4.84022 1.54004 5.30387M5.29943 16.4597C4.82211 16.4082 4.34928 16.3529 3.88136 16.2987C2.73614 16.1659 1.82277 15.2531 1.69423 14.1074L1.69045 14.0736C1.63943 13.6189 1.58788 13.1595 1.54004 12.6959",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinScan);
export default __webpack_public_path__ + "static/media/skin_scan.99ca71de4157ae282e4c5700e81bfc01.svg";
export { ForwardRef as ReactComponent };